/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Tracks user-specific favorite reports. Report Favorites remain the same across all venues which the user has access to in a particular organisation.
 */
export interface ReportFavouriteInsert { 
    /**
     * ID of the user; unique with report_id + org_ref_id to prevent duplicates.
     */
    userId: string;
    /**
     * Foreign key referencing Reports table.
     */
    reportId: number;
    organisationId: string;
}